import { createContext } from 'react';

export const DEFAULT_VALUE: {
  authType?: 'sms' | 'waitcall'
  recoveryType?: 'sms' | 'waitcall',
} = {
  authType: 'waitcall',
  recoveryType: 'sms',
}

export const AuthConfigContext = createContext(DEFAULT_VALUE)